import styled from "styled-components";

const WorkSegmentHeader = styled.div`
  margin: 0 0 64px 0;
`;

export { WorkSegmentHeader };
